import type {} from "@lit/react";
import { UploadButton as UploadButtonElement, } from "@vaadin/upload/vaadin-upload-button.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { UploadButtonElement, };
export type UploadButtonEventMap = Readonly<{}>;
const events = {} as UploadButtonEventMap;
export type UploadButtonProps = WebComponentProps<UploadButtonElement, UploadButtonEventMap>;
export const UploadButton = createComponent({
    elementClass: UploadButtonElement, events, react: React, tagName: "vaadin-upload-button"
});
